/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReceiveUSPSDialog.vue?vue&type=template&id=e6e1d0ca"
import script from "./ReceiveUSPSDialog.vue?vue&type=script&lang=js"
export * from "./ReceiveUSPSDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6e1d0ca')) {
      api.createRecord('e6e1d0ca', component.options)
    } else {
      api.reload('e6e1d0ca', component.options)
    }
    module.hot.accept("./ReceiveUSPSDialog.vue?vue&type=template&id=e6e1d0ca", function () {
      api.rerender('e6e1d0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/ReceiveUSPSDialog.vue"
export default component.exports